import { Capacitor, registerPlugin } from '@capacitor/core';

export interface NativeTokens {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
}

interface SecureTokenPlugin {
  load(): Promise<{ available: boolean; tokens?: NativeTokens }>;
  save(tokens: NativeTokens): Promise<{ saved: boolean }>;
  clear(): Promise<{ cleared: boolean }>;
  googleSignIn(options: { url: string }): Promise<{ code: string }>;
}

const SecureToken = registerPlugin<SecureTokenPlugin>('SecureToken');
let tokens: NativeTokens | null = null;

export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
}

export async function restoreNativeTokens(): Promise<NativeTokens | null> {
  if (!isNativeApp()) return null;
  try {
    const result = await SecureToken.load();
    tokens = result.available && result.tokens ? result.tokens : null;
  } catch {
    tokens = null;
  }
  return tokens;
}

export function getNativeAccessToken(): string | null {
  return tokens?.accessToken ?? null;
}

export function getNativeRefreshToken(): string | null {
  return tokens?.refreshToken ?? null;
}

export async function saveNativeTokens(accessToken: string, refreshToken: string, expiresIn: number): Promise<void> {
  tokens = { accessToken, refreshToken, expiresAt: Date.now() + expiresIn * 1000 };
  if (isNativeApp()) await SecureToken.save(tokens);
}

export async function clearNativeTokens(): Promise<void> {
  tokens = null;
  if (isNativeApp()) await SecureToken.clear().catch(() => undefined);
}

export async function beginNativeGoogleSignIn(): Promise<string> {
  if (!isNativeApp()) throw new Error('此登入方式只適用於 iOS App');
  const result = await SecureToken.googleSignIn({ url: 'https://hengri-wellness.pages.dev/api/v1/auth/google/start?client=ios' });
  return result.code;
}
